import {
	Box,
	Button,
	Container,
	Paper,
	Stack,
	Text,
	Title,
} from "@mantine/core";
import { IconRefresh } from "@tabler/icons-react";
import { useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

interface ErrorBoundaryProps {
	error: Error;
	errorComponent?: React.ReactNode;
}

function formatErrorMessage(error: Error): string {
	return (
		error?.message || "An unexpected error occurred. Please try again later."
	);
}

export function ErrorBoundary({ error, errorComponent }: ErrorBoundaryProps) {
	const navigate = useNavigate();

	useEffect(() => {
		// Log error to your error reporting service
		console.error("Error caught by boundary:", error);
	}, [error]);

	if (errorComponent) {
		return errorComponent;
	}

	return (
		<Container size="100%" py="xl">
			<Stack align="center" gap="md">
				<Title order={2}>Something went wrong</Title>
				<Paper withBorder p="md" radius="md" bg="red.0" w="100%">
					<Box p="md">
						<pre
							style={{
								margin: 0,
								whiteSpace: "pre-wrap",
								wordBreak: "break-word",
							}}
						>
							<Text c="red" fw={500}>
								{formatErrorMessage(error)}
							</Text>
						</pre>
					</Box>
				</Paper>
				<Button
					leftSection={<IconRefresh size={16} />}
					variant="light"
					onClick={() => navigate({ to: "/" })}
				>
					Return to Home
				</Button>
			</Stack>
		</Container>
	);
}
